import { render } from "./UpdateUserRolePage.vue?vue&type=template&id=14e8df60&ts=true"
import script from "./UpdateUserRolePage.vue?vue&type=script&lang=ts"
export * from "./UpdateUserRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__